export default "__VITE_ASSET__6a04136f__"